import React, { useEffect, useLayoutEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { ReactSearchAutocomplete } from "react-search-autocomplete";
import { TrackEvent } from "./utils";

export function Search(props) {
  const navigate = useNavigate();
  const [searchString, setSearchString] = useState("");
  const [searchResults, setSearchResults] = useState([]);
  const [hoverChange, sethoverChange] = useState(false);
  const [helperMsg, setHelperMsg] = useState(false);
  const parentAutocompleteRef = useRef(null);

  // create unformatted content property
  // strips HTML tags and returns/newlines
  props.data.articles.map((item, i) => {
    item.unformattedContent = item.content.replace(/(<([^>]+)>)/ig, "").replace(/\r\n/ig, " ");
  });


  const handleHelperMsgInputBlur = (e) => {
    setHelperMsg(false);
    parentAutocompleteRef.current.querySelector('input').removeEventListener("blur", handleHelperMsgInputBlur);
  }

  const handleOnSearch = (string, results) => {
    setSearchString(string);
    setSearchResults(results);
    setHelperMsg(false);
  };

  const handleOnSubmit = (e) => {
    e.preventDefault();

    // show helper message on submit
    // if (searchResults.length === 0 && searchString.length > 1) {    
    setHelperMsg(true);
    parentAutocompleteRef.current.querySelector('input').addEventListener("blur", handleHelperMsgInputBlur);
    // }
  }

  const handleOnHover = (result) => {
    // trigger hoverChange
    sethoverChange(!hoverChange);
  };

  const handleOnSelect = (item) => {
    // programmatically follow url
    navigate(`/resource-centre/${item.categorySlug}/${item.slug}`);

    TrackEvent('search', { 'context': parentAutocompleteRef.current.querySelector('input').value });
  };

  const handleOnClear = () => {
    setHelperMsg(false);
  };

  // trigger scrollIntoView on every onHover event
  useLayoutEffect(() => {
    let selected = document.querySelector('.contact-search__input ul li[data-test="result"].selected');
    selected?.scrollIntoView({ behavior: "smooth", block: "nearest", inline: "nearest" });
  }, [hoverChange]);



  const formatResult = (item) => {
    return (
      <div style={{ cursor: "pointer" }}>
        <strong style={{ display: "block", textAlign: "left", margin: "2px 0 6px" }}>
          <span style={{ display: "block", margin: "0 0 -5px" }}>
            {item.longTitle ? item.longTitle : item.title}
          </span>
          {
            <small className="contact-search__breadcrumbs">
              <span className="contact-search__breadcrumbs-category">{item.category}</span>
              {item.subCategory && <span className="contact-search__breadcrumbs-subcategory"> &gt; {item.subCategory}</span>}
            </small>
          }
        </strong>
        {/*
        <span className="contact-search__copy">
          {item.content
            .replace(/(<([^>]+)>)/ig, "") // html tags
            .replace(/&lsquo;/g, "‘")
            .replace(/&rsquo;/g, "’")
            .replace(/&nbsp;/g, " ")}            
        </span> 
        */}
        <span className="contact-search__copy" dangerouslySetInnerHTML={{
          __html: item.unformattedContent
        }}>
        </span>
      </div>
    );
  };
  return (
    <div className="contact-search">
      <h1>{props.data.searchTitle}</h1>
      <form className="contact-search__input" onSubmit={handleOnSubmit} ref={parentAutocompleteRef}>
        <ReactSearchAutocomplete
          items={props.data.articles}
          fuseOptions={{
            threshold: props.data.searchThreshold, // default: 0.6
            // distance: 1000, // default: 100
            // location: 0, // default: 0
            ignoreLocation: true, // ignore distance and location
            minMatchCharLength: 2,
            keys: ["title", "longTitle", "unformattedContent", "keywords"]
          }}
          resultStringKeyName="longTitle" // content overwritten in formatResult function
          showNoResults={true}
          showNoResultsText={props.data.searchNoResultsText}
          showIcon={true}
          onSearch={handleOnSearch}
          onHover={handleOnHover}
          onSelect={handleOnSelect}
          // onFocus={handleOnFocus}
          onClear={handleOnClear}
          // inputSearchString={searchString} // causing bug on keyboard result select
          maxResults={15}
          placeholder={props.data.searchPlaceholder}
          autoFocus={true}
          formatResult={formatResult}
          styling={{
            color: "#313537",
            backgroundColor: "white",
            hoverBackgroundColor: "#f1f2f2",
            borderRadius: "0",
            border: "none none 1px solid #d1d3d4 none",
            boxShadow: "none",
            height: "52px",
            fontSize: "18px",
            fontFamily: "Roboto",
            iconColor: "#939598",
            lineColor: "#fff",
            placeholderColor: "#808285",
            clearIconMargin: '3px 14px 0 0',
            searchIconMargin: '0 0 0 16px'
          }}
        />
        {helperMsg && <div className="contact-search__msg">
          {props.data.searchHelperText}
        </div>}
      </form>

    </div>
  );
}
